import React, { FC } from 'react'
import styled, { css } from 'styled-components'

import LeftArrow from '@Components/Product/Slider/Components/Arrow/LeftArrow'
import RightArrow from '@Components/Product/Slider/Components/Arrow/RightArrow'
import { up } from '@Globals/Style/breakpoints'

interface Props {
  onClickLeft: (event) => void
  onClickRight: (event) => void
}

const StyledArrow = css`
  display: none;

  ${up('mobileStyleThreshold')} {
    display: block;
    position: absolute;
    top: calc(50% - 19px);
    height: 38px;
    width: 38px;
    z-index: 1;
    background-color: rgba(236, 236, 236, 0.8);
    padding: 0 10px;
    font-size: 1.7rem;
    font-weight: lighter;
    cursor: pointer;
  }
`

const StyledLeftArrow = styled(LeftArrow)`
  left: 0;
  ${StyledArrow}
`

const StyledRightArrow = styled(RightArrow)`
  right: 0;
  ${StyledArrow}
`

const ArrowPagination: FC<Props> = ({ onClickLeft, onClickRight }) => {
  const handleRightClick = (event) => {
    event.stopPropagation()
    onClickRight(event)
  }
  const handleLeftClick = (event) => {
    event.stopPropagation()
    onClickLeft(event)
  }

  return (
    <>
      <StyledLeftArrow onClick={handleLeftClick} />
      <StyledRightArrow onClick={handleRightClick} />
    </>
  )
}

export default ArrowPagination
